export default "__VITE_ASSET__CIU7c4gG__"